import * as React from 'react'
import { Box, Drawer, IconButton, Toolbar } from '@mui/material'
import BrockSideBar from './BrockSideBar'
import MenuIcon from '@mui/icons-material/Menu'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'

const EXPANDED_WIDTH = 248
const COLLAPSED_WIDTH = 30

export default function BrockAppBar({
	open,
	setOpen,
}: {
	open: boolean
	setOpen: React.Dispatch<React.SetStateAction<boolean>>
}) {
	return (
		<Drawer
			open={open}
			variant='permanent'
			sx={{
				width: open ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
				flexShrink: 0,
				['& .MuiDrawer-paper']: {
					width: open ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
					boxSizing: 'border-box',
					overflowX: 'hidden',
					transition: (theme) =>
						theme.transitions.create('width', {
							easing: theme.transitions.easing.easeInOut,
							duration: theme.transitions.duration.standard,
						}),
				},
			}}
		>
			<Toolbar />

			<Box display={'flex'} height={'100%'} gap={0} bgcolor={'#E0E0E0'}>
				<Box
					sx={{
						width: open ? EXPANDED_WIDTH - COLLAPSED_WIDTH : '0px',
						transition: 'width 0.3s ease-in-out',
					}}
				>
					{open && <BrockSideBar />}
				</Box>
				{/* Open and close button */}
				<IconButton
					onClick={() => setOpen(!open)}
					sx={{
						borderRadius: '0',
						width: COLLAPSED_WIDTH,
						bgcolor: '#f5f5f5',
						color: '#333',
						'&:hover': {
							bgcolor: '#ddd', 
						},
					}}
				>
					{open ? <ChevronLeftIcon fontSize='small' /> : <MenuIcon fontSize='small' />}
				</IconButton>
			</Box>
		</Drawer>
	)
}
